import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MenuComponent, MenuTriggerDirective } from 'shared/ui-common';
import { OrganisationSettingsService } from 'shared/util-common';

import { ColorPreset } from '@treetop/shared/color-presets';

import { ColorPresetCardComponent } from '../../color-presets-tab/color-preseet-card/color-preset-card.component';
import { FlowchartNodeConfig } from '../flowchart-customisations-settings-tab.component';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-customisable-flowchart-element',
  templateUrl: './customisable-flowchart-element.component.html',
  styleUrls: ['./customisable-flowchart-element.component.scss'],
  host: {
    '[style.--tt-flowchart-element-fill]': 'colorPresetBg()',
    '[style.--tt-flowchart-element-stroke]': 'colorPresetStroke()',
    '[style.--tt-flowchart-element-text]': 'colorPresetText()',
  },
  imports: [ColorPresetCardComponent, MenuComponent, TranslocoPipe, MenuTriggerDirective],
})
export class CustomisableFlowchartElementComponent {
  private organisationSettingsService = inject(OrganisationSettingsService);

  public flowchartNodeConfig = input.required<FlowchartNodeConfig>();
  public colorPresets = input<ColorPreset[] | undefined>();

  public colorPresetChanged = output<string>();

  protected menuColorPresets = computed(() => this.colorPresets() ?? this.organisationSettingsService.settings().customisations?.colorPresets ?? []);

  protected colorPreset = computed(() => this.flowchartNodeConfig().colorPreset);

  protected colorPresetBg = computed(() => {
    const preset = this.colorPreset();
    return preset ? `var(--tt-color-preset-${preset.id}-fill)` : `var(--tt-flowchart-${this.flowchartNodeConfig().type}-fill)`;
  });

  protected colorPresetStroke = computed(() => {
    const preset = this.colorPreset();
    return preset ? `var(--tt-color-preset-${preset.id}-stroke)` : `var(--tt-flowchart-${this.flowchartNodeConfig().type}-stroke)`;
  });

  protected colorPresetText = computed(() => {
    const preset = this.colorPreset();
    return preset ? `var(--tt-color-preset-${preset.id}-text)` : `var(--tt-flowchart-${this.flowchartNodeConfig().type}-text)`;
  });
}
